module.exports = __webpack_public_path__ + "img/firebase.0271d2c6.png";